import Logout from "@mui/icons-material/Logout";
import { ListItemIcon, MenuItem } from "@mui/material";
import { useContext } from "react";
import { AuthContext } from '../../../contexts/AuthContext'
import React from 'react';

export default function MenuItemLogout() {
    const { signOut } = useContext(AuthContext)
    return (
        <MenuItem onClick={signOut}>
            <ListItemIcon>
                <Logout fontSize="small" />
            </ListItemIcon>
            Sair da conta
        </MenuItem>
    )
}